export class SavedSearchValidator {
  static isNameValid(name: string): boolean {
    return name.trim().length !== 0;
  }
}
